import {openModal} from "../functions/openModal";

document.addEventListener('DOMContentLoaded', () => {

    let municipalityRedirectForm = document.querySelector('.municipality-redirect-form')

    if (municipalityRedirectForm) {
        municipalityRedirectForm.addEventListener('submit', event => {
            event.preventDefault()
            let url = municipalityRedirectForm.municipality.value
            if (url) {
                window.location = url
            }
        })
    }

    document.querySelectorAll('.municipal-district-select-redirect').forEach(select => {
        select.addEventListener('change', () => {
            let url = select.value
            if (url) {
                window.location = url
            }
        })
    })
})

;(function (document, window) {
    $('.js-load-more-afisha').on('click', function (event) {
        let $this = $(this);
        var page = $this.data('page') * 1 + 1;
        $this.data('page', page);
        $.ajax({
            type: 'get',
            url: '/ajax/forum',
            data: {page: page},
            dataType: 'json',
            success: function (response) {
                $('.js-index-afisha-container').append(response.content);
                if (!response.hasAdditionalForums) {
                    $this.hide();
                }
            },
        })
    })
})(document, window);
